var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNikeSwoosh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 40,
    viewBox: "0 0 116 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5091_5154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.287 0L31.4644 35.6016C24.5133 38.5339 18.6767 40 13.9547 40C8.59917 40 4.72105 38.1333 2.32031 34.3998C0.805994 32.0053 0.36001 28.9607 0.982356 25.2659C1.6047 21.5711 3.25106 17.6378 5.92142 13.466C8.15595 10.0861 11.8134 5.64166 16.8937 0.132614C15.1694 2.84049 13.905 5.81363 13.1513 8.93217C11.8143 14.6217 13.0147 18.8 16.7525 21.4671C18.5345 22.7122 20.9851 23.3347 24.1043 23.3347C26.9504 23.2864 29.7793 22.8836 32.5253 22.1357L115.287 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5091_5154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114.576,
    height: 40,
    fill: "white",
    transform: "translate(0.710938)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNikeSwoosh);
export default __webpack_public_path__ + "static/media/nikeSwoosh.c255ac2e2210b1c9598fe854fbf0eb3e.svg";
export { ForwardRef as ReactComponent };